// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e173d1f1","952":"9f64c651"}[chunkId] + ".chunk.js";
};